<template>
  <div>
    <p v-if="document.data && document.data.veryImportantErrors" class="text-danger font-larger font-weight-bold">
      {{ document.data.veryImportantErrors }}
    </p>

    <p>
      Aby złożyć dokument z podpisem kwalifikowanym należy pobrać dokument, podpisać podpisem kwalifikowanym, a
      następnie wgrać go z podpisem.
    </p>

    <div v-if="!!schema.signedAttachmentId.$model">
      <p>Poprawnie dodano podpisany dokument</p>

      <p>{{ signature(uploadedAttachment) }}</p>
    </div>

    <div v-else>
      <post-form button-class="mb-4 btn-light" icon="fal fa-cloud-download mr-2" text="Pobierz" :url="renderUrl" />

      <attachment-upload
        add-files-text="Wgraj podpisany dokument"
        :additional-metadata="additionalMetadata"
        :entity-type="entityType"
        :entity-id="entityId"
        :model="$schema.attachments"
        @signedAttachmentAdded="signedAttachmentAdded"
      />
    </div>

    <w-radio-list
      v-if="schema.sendByEmail"
      class="mt-3"
      title="Odpowiedź proszę przekazać"
      :model="schema.sendByEmail"
      :values="sendByEmailValues"
    />

    <w-input class="mt-3" title="Adres e-mail" :model="schema.email" />
  </div>
</template>

<script>
import { mapState } from 'vuex';

import AttachmentUpload from '@/components/formComponents/attachment/AttachmentUpload';
import PostForm from '@/components/postForm/PostForm';
import { EntityType } from '@/enums/entityType.enum';
import { PublicSettings } from '@/enums/publicSettings.enum';
import { documentRenderMixin } from '@/mixins/document/documentRender';
import { formMixin } from '@/mixins/form';
import { signatureMixin } from '@/mixins/signature';
import schema from '@/schemas/documentAttachments.schema';

// @vuese
// Modal podpisywania dokumentu podpisem kwalifikowanym
// @group ActionData
export default {
  components: { AttachmentUpload, PostForm },
  mixins: [formMixin, documentRenderMixin, signatureMixin],
  props: {
    // schema akcji
    schema: { type: Object, required: true }
  },
  schema,
  data() {
    return {
      files: undefined,
      entityType: EntityType.DOCUMENT,
      entityId: this.$route.params.documentId.toString(),
      model: {},
      sendByEmailValues: [
        { value: true, text: 'w formie elektronicznej' },
        { value: false, text: 'w formie papierowej' }
      ],
      uploadedAttachment: undefined
    };
  },
  computed: {
    ...mapState({ document: state => state.document.data }),
    additionalMetadata() {
      return { signedDocumentChecksum: this.document.checksum };
    }
  },
  beforeMount() {
    this.schema.signedAttachmentId.$setData(null);
  },
  methods: {
    // @vuese
    // Zapisanie do schemy przycisku id załącznika podpisanego dokumentu
    signedAttachmentAdded(attachment) {
      this.uploadedAttachment = attachment;
      this.schema.signedAttachmentId.$setData(attachment.id);
    }
  }
};
</script>
